"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _asicsPerfJp = _interopRequireDefault(require("./asics-perf-jp"));

var _asicsStudio = _interopRequireDefault(require("./asics-studio"));

var _asicsWalking = _interopRequireDefault(require("./asics-walking"));

var _haglofs = _interopRequireDefault(require("./haglofs"));

var _minduplifter = _interopRequireDefault(require("./minduplifter"));

var _onitsukaTigerAna = _interopRequireDefault(require("./onitsuka-tiger-ana"));

var _onitsukaTigerUk = _interopRequireDefault(require("./onitsuka-tiger-uk"));

var _raceroster = _interopRequireDefault(require("./raceroster-25"));

var _rebrandLite = _interopRequireDefault(require("./rebrand-lite"));

var _runkeeper = _interopRequireDefault(require("./runkeeper"));

var _stepnote = _interopRequireDefault(require("./stepnote"));

var _teamRed = _interopRequireDefault(require("./team-red"));

var _default = {
  aeg_outlet_instore: _rebrandLite.default,
  // delete?
  aeg_outlet_instore_uk_only: _rebrandLite.default,
  // delete?
  aesop: _rebrandLite.default,
  asics_mobile_jp: _asicsPerfJp.default,
  asics_outlet_eu: _rebrandLite.default,
  asics_perf_ana: _rebrandLite.default,
  asics_perf_au: _rebrandLite.default,
  asics_perf_jp: _asicsPerfJp.default,
  asics_perf_kr: _rebrandLite.default,
  asics_perf_marathon: _rebrandLite.default,
  // delete?
  asics_perf_uk: _rebrandLite.default,
  asics_studio: _asicsStudio.default,
  asics_walking: _asicsWalking.default,
  haglofs: _haglofs.default,
  minduplifter: _minduplifter.default,
  oasis: _rebrandLite.default,
  onitsuka_tiger_ana: _onitsukaTigerAna.default,
  onitsuka_tiger_au: _onitsukaTigerAna.default,
  onitsuka_tiger_uk: _onitsukaTigerUk.default,
  onitsuka_tiger_kr: _onitsukaTigerAna.default,
  raceroster_25: _raceroster.default,
  // delete?
  raceroster_rkgo: _raceroster.default,
  // delete?
  runkeeper: _runkeeper.default,
  stepnote: _stepnote.default,
  team_red: _teamRed.default
};
exports.default = _default;